const contexts = require.context('.', false, /\.vue$/)
const modules = []
contexts.keys().forEach(key => {
  // console.log("key", key);
  let item = contexts(key).default
  modules.push(item)
})
export default modules



// WEBPACK FOOTER //
// ./src/components/index.js